<!-- Modal Overlay - ISSUE 4 FIX: Removed (click)="onClose()" to prevent backdrop close -->
<div *ngIf="isVisible" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">

  <!-- Modal Content -->
  <div class="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden"
    (click)="$event.stopPropagation()">

    <!-- Modal Header -->
    <div class="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <h3 class="text-xl font-bold">{{ receiptTitle }}</h3>
          <div class="flex items-center space-x-2">
            <span class="text-sm opacity-90">{{ receiptIndex + 1 }} de {{ totalReceipts }}</span>
            <div class="flex items-center space-x-1 text-sm">
              <span [class]="getStatusColor()">{{ getStatusIcon() }}</span>
              <span class="opacity-90">{{ getStatusText() }}</span>
            </div>
          </div>
        </div>

        <!-- Navigation and Close -->
        <div class="flex items-center space-x-2">
          <!-- Previous Receipt -->
          <button type="button" [disabled]="!canNavigatePrevious" (click)="navigatePrevious()"
            class="p-2 rounded-lg bg-white bg-opacity-20 hover:bg-opacity-30 disabled:opacity-50 disabled:cursor-not-allowed transition-all">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clip-rule="evenodd"></path>
            </svg>
          </button>

          <!-- Next Receipt -->
          <button type="button" [disabled]="!canNavigateNext" (click)="navigateNext()"
            class="p-2 rounded-lg bg-white bg-opacity-20 hover:bg-opacity-30 disabled:opacity-50 disabled:cursor-not-allowed transition-all">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"></path>
            </svg>
          </button>

          <!-- Close Button -->
          <button type="button" (click)="onClose()"
            class="p-2 rounded-lg bg-white bg-opacity-20 hover:bg-opacity-30 transition-all">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Tabs -->
      <div class="flex space-x-1 mt-4">
        <button type="button" (click)="setActiveTab('basic')"
          [class]="activeTab === 'basic' ? 'bg-white bg-opacity-20 text-white' : 'text-blue-100 hover:text-white hover:bg-white hover:bg-opacity-10'"
          class="px-4 py-2 rounded-lg font-medium transition-all">
          📋 Datos Básicos
        </button>
        <button type="button" (click)="setActiveTab('fees')"
          [class]="activeTab === 'fees' ? 'bg-white bg-opacity-20 text-white' : 'text-blue-100 hover:text-white hover:bg-white hover:bg-opacity-10'"
          class="px-4 py-2 rounded-lg font-medium transition-all">
          💸 Fees/Descuentos
        </button>
        <button type="button" (click)="setActiveTab('summary')"
          [class]="activeTab === 'summary' ? 'bg-white bg-opacity-20 text-white' : 'text-blue-100 hover:text-white hover:bg-white hover:bg-opacity-10'"
          class="px-4 py-2 rounded-lg font-medium transition-all">
          📊 Resumen
        </button>
      </div>
    </div>

    <!-- Modal Body -->
    <div class="p-6 overflow-y-auto max-h-[calc(90vh-200px)]" *ngIf="receiptFormGroup">

      <!-- TAB: Datos Básicos -->
      <div *ngIf="activeTab === 'basic'" [formGroup]="receiptFormGroup">

        <!-- Información del Comprobante -->
        <div class="bg-gray-50 rounded-lg p-4 mb-6">
          <h4 class="font-semibold text-gray-800 mb-3">📄 Información del Comprobante</h4>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <span class="text-sm font-medium text-gray-600">Concepto:</span>
              <div class="font-semibold text-gray-800">{{ receipt?.concept }}</div>
            </div>
            <div>
              <span class="text-sm font-medium text-gray-600">Fecha:</span>
              <div class="font-semibold text-gray-800">
                {{ receipt?.type === 'income'
                ? formatDate(receipt?.transactionDate)
                : formatDate(receipt?.paymentDate) }}
              </div>
            </div>
            <div>
              <span class="text-sm font-medium text-gray-600">Monto Original:</span>
              <div class="font-semibold text-green-600">{{ formatCurrency(originalAmount) }}</div>
            </div>
          </div>
        </div>

        <!-- Configuración de Montos -->
        <div class="space-y-6">
          <!-- Monto en el Banco -->
          <div>
            <label class="block text-gray-700 font-bold mb-2" appRequiredLabel>
              💵 Monto en el Banco
            </label>
            <input type="text" appCurrencyFormatter formControlName="bankAmount" (input)="calculateTotals()"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Monto reportado por el banco" />
            <div *ngIf="receiptFormGroup.get('bankAmount')?.invalid && receiptFormGroup.get('bankAmount')?.touched"
              class="text-red-500 text-sm mt-1">
              Monto del banco es obligatorio.
            </div>
            <p class="text-xs text-gray-500 mt-1">Monto específico reportado por el banco para este comprobante</p>
          </div>

          <!-- Razón de Ajuste -->
          <div>
            <label class="block text-gray-700 font-bold mb-2">📝 Razón de Ajuste</label>
            <input type="text" formControlName="adjustmentReason"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Razón del ajuste si hay diferencia" />
            <p class="text-xs text-gray-500 mt-1">Justificación si hay diferencia entre montos</p>
          </div>

          <!-- Notas Específicas -->
          <div>
            <label class="block text-gray-700 font-bold mb-2">📋 Notas Específicas</label>
            <textarea formControlName="notes"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
              rows="3" placeholder="Notas específicas para este comprobante"></textarea>
          </div>
        </div>
      </div>

      <!-- TAB: Fees/Descuentos -->
      <div *ngIf="activeTab === 'fees'" [formGroup]="receiptFormGroup">

        <!-- Header con botón agregar -->
        <div class="flex items-center justify-between mb-6">
          <h4 class="text-lg font-semibold text-gray-800">💸 Descuentos/Retenciones</h4>
          <button type="button" (click)="addFee()"
            class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2">
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                clip-rule="evenodd"></path>
            </svg>
            Agregar Fee
          </button>
        </div>

        <!-- Lista de Fees -->
        <div formArrayName="feeDetails" class="space-y-4">
          <div *ngFor="let feeControl of getFeeDetailsArray().controls; let i = index" [formGroupName]="i"
            class="border border-gray-300 rounded-lg p-4 bg-gray-50">

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <!-- Tipo de Fee -->
              <div>
                <label class="block text-gray-700 font-semibold mb-2">Tipo de Fee</label>
                <select formControlName="feeTypeId" (change)="onFeeChange(i)"
                  class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500">
                  <option value="" disabled>Seleccione un tipo</option>
                  <option *ngFor="let type of feeTypes" [value]="type.id">{{ type.name }}</option>
                </select>
              </div>

              <!-- Monto -->
              <div>
                <label class="block text-gray-700 font-semibold mb-2">Monto</label>
                <input type="text" formControlName="requestAmount" (input)="onFeeChange(i)"
                  class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="50000 o 10%" />
                <span class="text-xs text-gray-500">Valor fijo ej: 50000, o porcentaje ej: 10%</span>
              </div>

              <!-- Descripción -->
              <div>
                <label class="block text-gray-700 font-semibold mb-2">Descripción</label>
                <input type="text" formControlName="description"
                  class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Descripción del fee" />
              </div>

              <!-- Monto Calculado -->
              <div>
                <label class="block text-gray-700 font-semibold mb-2">Monto Calculado</label>
                <input type="text" appCurrencyFormatter formControlName="amount" readonly
                  class="w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-lg font-semibold text-blue-600" />
              </div>
            </div>

            <!-- Botón eliminar fee -->
            <button type="button" (click)="removeFee(i)"
              class="mt-3 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                </path>
              </svg>
              Eliminar Fee
            </button>
          </div>

          <!-- Mensaje si no hay fees -->
          <div *ngIf="getFeeDetailsArray().length === 0"
            class="text-center py-8 text-gray-500 italic border-2 border-dashed border-gray-300 rounded-lg">
            <svg class="w-12 h-12 mx-auto mb-3 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6">
              </path>
            </svg>
            No hay fees/descuentos agregados para este comprobante
          </div>
        </div>
      </div>

      <!-- TAB: Resumen -->
      <div *ngIf="activeTab === 'summary'">

        <!-- Resumen Visual -->
        <div class="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-200">
          <h4 class="text-lg font-bold text-gray-800 mb-4">📊 Resumen de Configuración</h4>

          <!-- Métricas principales -->
          <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            <div class="bg-white p-4 rounded-lg border shadow-sm">
              <div class="text-sm font-medium text-gray-600 mb-1">Original</div>
              <div class="text-lg font-bold text-gray-800">{{ formatCurrency(originalAmount) }}</div>
            </div>
            <div class="bg-white p-4 rounded-lg border shadow-sm">
              <div class="text-sm font-medium text-gray-600 mb-1">Banco</div>
              <div class="text-lg font-bold text-blue-600">{{ formatCurrency(bankAmount) }}</div>
            </div>
            <div class="bg-white p-4 rounded-lg border shadow-sm">
              <div class="text-sm font-medium text-gray-600 mb-1">Total Fees</div>
              <div class="text-lg font-bold text-purple-600">{{ formatCurrency(totalFees) }}</div>
            </div>
            <div class="bg-white p-4 rounded-lg border shadow-sm">
              <div class="text-sm font-medium text-gray-600 mb-1">Diferencia Final</div>
              <div class="text-lg font-bold" [ngClass]="{
                     'text-green-600': isBalanced,
                     'text-red-600': !isBalanced
                   }">
                {{ formatCurrency(finalDifference) }}
              </div>
            </div>
          </div>

          <!-- Estado de Balance -->
          <div class="flex items-center justify-center p-4 rounded-lg" [ngClass]="{
                 'bg-green-100 border border-green-300': isBalanced,
                 'bg-red-100 border border-red-300': !isBalanced
               }">
            <div class="flex items-center space-x-3">
              <div class="w-3 h-3 rounded-full" [ngClass]="{
                     'bg-green-500': isBalanced,
                     'bg-red-500': !isBalanced
                   }"></div>
              <span class="font-semibold text-lg" [ngClass]="{
                      'text-green-700': isBalanced,
                      'text-red-700': !isBalanced
                    }">
                {{ isBalanced ? '✅ Comprobante Balanceado' : '⚠️ Comprobante con Diferencias' }}
              </span>
            </div>
          </div>

          <!-- Explicación del cálculo -->
          <div class="mt-4 p-4 bg-white rounded-lg border">
            <h5 class="font-semibold text-gray-800 mb-2">🧮 Cálculo:</h5>
            <div class="text-sm text-gray-700 space-y-1">
              <div>Monto Banco: {{ formatCurrency(bankAmount) }}</div>
              <div>Monto Original: {{ formatCurrency(originalAmount) }}</div>
              <div>Total Fees: {{ formatCurrency(totalFees) }}</div>
              <div class="border-t pt-1 font-semibold">
                Diferencia = Banco - (Original - Fees) = {{ formatCurrency(finalDifference) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="bg-gray-50 px-6 py-4 flex items-center justify-between border-t">
      <div class="flex items-center space-x-4">
        <!-- Status indicator -->
        <div class="flex items-center space-x-2">
          <span [class]="getStatusColor()">{{ getStatusIcon() }}</span>
          <span class="text-sm font-medium text-gray-700">{{ getStatusText() }}</span>
        </div>
      </div>

      <div class="flex items-center space-x-3">
        <button type="button" (click)="onClose()"
          class="px-4 py-2 text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-lg transition-colors">
          Cancelar
        </button>
        <button type="button" (click)="onSave()" [disabled]="!receiptFormGroup?.valid"
          class="px-6 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white rounded-lg transition-colors">
          Guardar y Continuar
        </button>
      </div>
    </div>
  </div>
</div>